// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { LoginV3Component } from "src/app/components/login-views/login-v3/login-v3.component";

export const environment = {
    production: false,
    language: "sl",
    wgProfileHost: "https://obrockanje-api.pms-lj.si",
    //wgProfileHost: "http://localgo-api.galisonline.eu",
    wgPlatformHost: "https://obrockanje-platform.pms-lj.si",

    loginComponent: LoginV3Component,
    projIcon: "/assets/project-custom/images/brd-main-logo.png",
    sidebarIcon: "/assets/project-custom/images/brd-logo@3x.png",
    projectCode: "GO",
    projectName:"<span>Podatkovna zbirka Slovenskega centra za obročkanje ptičev</span>",
    projectSidebarName:"Zbirka",
    locale:'sl-SI',
    useRouteAndMasterpageCache:true,
    ADLoginEnabled:false,
    dateFormat:'DD.MM.YYYY',
    newRegistrationLinkDocument: "",
    navigateAwayPopupEnabled:true,
    useEtag:true
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
